// something@something.tld with no spaces; intentionally loose so valid but unusual addresses still pass
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// determines whether a string is shaped like an email address
export function isValidEmail(email: string) {
	return EMAIL_FORMAT.test(email.trim())
}
